// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen catalog-types directly.

export const catalogItemTypeMap = {
  CASEWORK_DESCRIPTOR: true,
  COLUMN_DESCRIPTOR: true,
  DOOR_DESCRIPTOR: true,
  DRAWING: true,
  LOAD_DESCRIPTOR: true,
  PROFILE_EXTRUSION_DESCRIPTOR: true,
  PROP: true,
  RAILING_SETTING: true,
  STAIR_SETTING: true,
  STRUCTURAL_MATERIAL: true,
  WALL_TYPE: true,
  WINDOW_DESCRIPTOR: true,
} as const;

export type CatalogItemType = keyof typeof catalogItemTypeMap;

export const catalogSettingsTypeKeys = {
  WALL_CATALOG_SETTINGS: true,
  DRAWING_CATALOG_SETTINGS: true,
  CASEWORK_CATALOG_SETTINGS: true,
  DOOR_CATALOG_SETTINGS: true,
  WINDOW_CATALOG_SETTINGS: true,
  COLUMN_CATALOG_SETTINGS: true,
  PROFILE_CATALOG_SETTINGS: true,
  STAIR_CATALOG_SETTINGS: true,
  RAILING_CATALOG_SETTINGS: true,
  ELECTRICAL_ITEM_CATALOG_SETTINGS: true,
} as const;

export type CatalogSettingsTypeLiterals = keyof typeof catalogSettingsTypeKeys;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen catalog-types directly.
